import React, { memo } from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { BILL_PAYMENT_CONSTANTS, IMAGES } from "./constant";
import {
    Container,
    IconAndTitleContainer,
    TitleContainer,
    DescriptionContainer,
    ButtonContainer,
    TextContainer,
    FlexCta,
} from "./styled";
import { IBillPaymentHalfCardContentProps } from "./types";

const BillPaymentHalfCardContent = memo(
    ({ onCtaClick, billPaymentCardData }: IBillPaymentHalfCardContentProps) => {
        const ctas = billPaymentCardData?.ctas || [];

        return (
            <Container>
                <IconAndTitleContainer>
                    <Image
                        cloudinaryId={billPaymentCardData?.paymentIcon || IMAGES.BILL_PAYMENT}
                        alt={billPaymentCardData?.iconAlt || BILL_PAYMENT_CONSTANTS.IMAGE_ALT}
                        cloudinaryHeight={
                            (billPaymentCardData?.iconHeight ||
                                BILL_PAYMENT_CONSTANTS.ICON_HEIGHT) * 2
                        }
                        cloudinaryWidth={
                            (billPaymentCardData?.iconWidth || BILL_PAYMENT_CONSTANTS.ICON_WIDTH) *
                            2
                        }
                        height={String(
                            billPaymentCardData?.iconHeight || BILL_PAYMENT_CONSTANTS.ICON_HEIGHT
                        )}
                        width={String(
                            billPaymentCardData?.iconWidth || BILL_PAYMENT_CONSTANTS.ICON_WIDTH
                        )}
                    />

                    <TextContainer>
                        <TitleContainer>
                            <Text variant="V2.heading1.neutral.bold" color="text_Highest_Emphasis">
                                {billPaymentCardData?.title || BILL_PAYMENT_CONSTANTS.TITLE}
                            </Text>
                        </TitleContainer>

                        <DescriptionContainer>
                            <Text variant="V2.body1.neutral.regular" color="text_Med_Emphasis">
                                {billPaymentCardData?.description ||
                                    BILL_PAYMENT_CONSTANTS.DESCRIPTION}
                            </Text>
                        </DescriptionContainer>
                    </TextContainer>
                </IconAndTitleContainer>

                {Array.isArray(ctas) && ctas.length > 0 && (
                    <ButtonContainer>
                        {ctas.map((cta, index) => {
                            if (!cta || !cta.text) {
                                return null;
                            }
                            return (
                                <FlexCta key={`cta-${index}-${cta.text}`}>
                                    <SuperButton
                                        buttonType={
                                            (cta.dlsType as "primary" | "secondary") || "primary"
                                        }
                                        buttonSize="large"
                                        onClick={() => onCtaClick(cta)}
                                    >
                                        {cta.text}
                                    </SuperButton>
                                </FlexCta>
                            );
                        })}
                    </ButtonContainer>
                )}
            </Container>
        );
    }
);

BillPaymentHalfCardContent.displayName = "BillPaymentHalfCardContent";

export default BillPaymentHalfCardContent;
